'use client';

import { useServicePopup } from './use-service-popup';
import { ServicePopupDialog } from './service-popup-dialog';
import { useServicePopupFacts } from './use-service-popup-facts';
import { useServicePopupHandler } from './use-service-popup-handler';

/**
 * **서비스 팝업 자리** — 로그인한 서비스 틀에 하나 붙는다. 재료(`useServicePopupFacts`) → 고르기(`useServicePopup`) → 단추(`useServicePopupHandler`) → 창.
 * @param live 서비스 틀이 문 구독본 — 워크스페이스 문서 · 타겟 키워드 세트 · 세트를 한 번이라도 받았나
 * @param pathname 지금 주소의 경로
 */
export function ServicePopupHost({ live, pathname }: { live: { workspace: Record<string, any> | null; campaigns: readonly Record<string, any>[]; campaignsReady: boolean }; pathname: string | null }) {
  const { facts, onboardingStatus, workspaceId } = useServicePopupFacts(live);
  const model = useServicePopup({ facts, workspaceId, pathname });
  const handler = useServicePopupHandler({ model, workspaceId, onboardingStatus });
  return <ServicePopupDialog kind={model.popup?.kind ?? null} copy={model.copy} onClose={handler.close} onAct={handler.act} onNever={handler.never} />;
}
